import { ICategoryQuery } from "../../models/category/query";
import { ICategory, ICategoryDetails } from "../../models/category/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import { CategoryLoading, IInternalState } from "./context";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";

type Action =
  | {
      type: "LOADING";
      payload: { loading: CategoryLoading | CategoryLoading[] };
    }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<ICategory> } }
  | { type: "SET_ALL_CATEGORIES"; payload: { data: ICategory[] } }
  | {
      type: "SET_LIST_LIGHT";
      payload: { light: IBaseListingResponse<ICategory> };
    }
  | { type: "SET_DETAILSS"; payload: { details?: ICategoryDetails } }
  | QueryAction<ICategoryQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }
    case "SET_ALL_CATEGORIES": {
      return {
        ...state,
        allCategories: action.payload.data,
      };
    }
    case "SET_LIST_LIGHT": {
      return {
        ...state,
        list: action.payload.light,
      };
    }
    case "SET_DETAILSS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
